import { Component,
         OnInit, AfterViewInit,
         ViewChild}                   from '@angular/core';
import { MatDialogRef,
         MatSelectionList }              from '@angular/material';
import { Observable }               from 'rxjs/Observable';
import { SortableFilter }           from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { BusRouteModel }            from './../bus-route-list/bus-route.model';
import { CurrencyService }          from '../shared/currency.service';

@Component({
  selector: 'sa-bus-route-dialog',
  template: require('./bus-route-dialog.component.html'),
  styles: [require('./bus-route-dialog.component.scss')]
})
export class BusRouteDialogComponent implements OnInit, AfterViewInit {

  public newItem = false;
  public model = new BusRouteModel();
  private errors = [];
  public currencyList = [];

  private dataReady = false;

  @ViewChild('currencies') currencies: MatSelectionList;

  constructor(
    public dialogRef: MatDialogRef<BusRouteDialogComponent>,
    public globals: Globals,
    private currencyService: CurrencyService
  ) {
  }

  public delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?\nTato změna je nevratná.')) {
      this.dialogRef.close('delete');
    }
  }

  public save() {

    this.model.busRouteCurrencies = this.currencies.selectedOptions.selected.map((v) => v.value.isoCode);

    this.errors = [];
    if (!this.model.routeName || this.model.routeName.length === 0) {
        this.errors.push('Zadejte prosím jméno trasy');
    }
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  ngOnInit() {
    this.currencyService.getItems().subscribe(resp => {
        this.currencyList = resp;
    });
  }

  public currencySelected(currency) {
    return this.model.busRouteCurrencies.findIndex(c => c === currency.isoCode) > -1;
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-route-dialog/bus-route-dialog.component.ts